import { Shovel } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const ShovelIcon = createLucideIcon(Shovel);
